import { render, staticRenderFns } from "./UserProfileFull.vue?vue&type=template&id=09240488&scoped=true&"
import script from "./UserProfileFull.vue?vue&type=script&lang=js&"
export * from "./UserProfileFull.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileFull.vue?vue&type=style&index=0&id=09240488&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09240488",
  null
  
)

export default component.exports